<i class="material-icons multi-clear-icon">backspace</i>
<span>{{ 'Clear' | translate }}</span>
